module.exports = __webpack_public_path__ + "static/media/about-us-top-illustration.745fdac4.png";